module.exports = __webpack_public_path__ + "img/pic-10.424e178e.jpg";